{
  "201": {
    "city": "Bayonne",
    "state": "NJ",
    "zipCode": "07002",
    "country": "US"
  },
  "202": {
    "city": "Washington",
    "state": "DC",
    "zipCode": "20001",
    "country": "US"
  },
  "203": {
    "city": "Bridgeport",
    "state": "CT",
    "zipCode": "06604",
    "country": "US"
  },
  "204": {
    "city": "Winnipeg",
    "state": "MB",
    "zipCode": "R2C0A5",
    "country": "CA"
  },
  "205": {
    "city": "Birmingham",
    "state": "AL",
    "zipCode": "35203",
    "country": "US"
  },
  "206": {
    "city": "Seattle",
    "state": "WA",
    "zipCode": "98101",
    "country": "US"
  },
  "207": {
    "city": "Portland",
    "state": "ME",
    "zipCode": "04101",
    "country": "US"
  },
  "208": {
    "city": "Boise",
    "state": "ID",
    "zipCode": "83702",
    "country": "US"
  },
  "209": {
    "city": "Lodi",
    "state": "CA",
    "zipCode": "95240",
    "country": "US"
  },
  "210": {
    "city": "San Antonio",
    "state": "TX",
    "zipCode": "78205",
    "country": "US"
  },
  "212": {
    "city": "New York City",
    "state": "NY",
    "zipCode": "10024",
    "country": "US"
  },
  "213": {
    "city": "Los Angeles",
    "state": "CA",
    "zipCode": "90015",
    "country": "US"
  },
  "214": {
    "city": "Dallas",
    "state": "TX",
    "zipCode": "75201",
    "country": "US"
  },
  "215": {
    "city": "Levittown",
    "state": "PA",
    "zipCode": "19054",
    "country": "US"
  },
  "216": {
    "city": "Cleveland",
    "state": "OH",
    "zipCode": "44101",
    "country": "US"
  },
  "217": {
    "city": "Champaign",
    "state": "IL",
    "zipCode": "61820",
    "country": "US"
  },
  "218": {
    "city": "Duluth",
    "state": "MN",
    "zipCode": "55802",
    "country": "US"
  },
  "219": {
    "city": "Gary",
    "state": "IN",
    "zipCode": "46402",
    "country": "US"
  },
  "220": {
    "city": "Athens",
    "state": "OH",
    "zipCode": "45701",
    "country": "US"
  },
  "223": {
    "city": "Lancaster",
    "state": "PA",
    "zipCode": "17602",
    "country": "US"
  },
  "224": {
    "city": "Arlington Heights",
    "state": "IL",
    "zipCode": "60004",
    "country": "US"
  },
  "225": {
    "city": "Baton Rouge",
    "state": "LA",
    "zipCode": "70801",
    "country": "US"
  },
  "226": {
    "city": "London",
    "state": "ON",
    "zipCode": "N5V0A2",
    "country": "CA"
  },
  "227": {
    "city": "Silver Spring",
    "state": "MD",
    "zipCode": "20901",
    "country": "US"
  },
  "228": {
    "city": "Biloxi",
    "state": "MS",
    "zipCode": "39530",
    "country": "US"
  },
  "229": {
    "city": "Albany",
    "state": "GA",
    "zipCode": "31701",
    "country": "US"
  },
  "231": {
    "city": "Grant",
    "state": "MI",
    "zipCode": "49327",
    "country": "US"
  },
  "234": {
    "city": "Akron",
    "state": "OH",
    "zipCode": "44301",
    "country": "US"
  },
  "235": {
    "city": "Columbia",
    "state": "MO",
    "zipCode": "65211",
    "country": "US"
  },
  "236": {
    "city": "Victoria",
    "state": "BC",
    "zipCode": "V8P5N3",
    "country": "CA"
  },
  "239": {
    "city": "Cape Coral",
    "state": "FL",
    "zipCode": "33904",
    "country": "US"
  },
  "240": {
    "city": "Aspen Hill",
    "state": "MD",
    "zipCode": "20906",
    "country": "US"
  },
  "248": {
    "city": "Farmington Hills",
    "state": "MI",
    "zipCode": "48331",
    "country": "US"
  },
  "249": {
    "city": "Sudbury",
    "state": "ON",
    "zipCode": "P3A0A4",
    "country": "CA"
  },
  "250": {
    "city": "Victoria",
    "state": "BC",
    "zipCode": "V8P5N3",
    "country": "CA"
  },
  "251": {
    "city": "Mobile",
    "state": "AL",
    "zipCode": "36601",
    "country": "US"
  },
  "252": {
    "city": "Elizabeth City",
    "state": "NC",
    "zipCode": "27909",
    "country": "US"
  },
  "253": {
    "city": "Kent",
    "state": "WA",
    "zipCode": "98030",
    "country": "US"
  },
  "254": {
    "city": "Eastland",
    "state": "TX",
    "zipCode": "76448",
    "country": "US"
  },
  "256": {
    "city": "Decatur",
    "state": "AL",
    "zipCode": "35601",
    "country": "US"
  },
  "257": {
    "city": "Vancouver",
    "state": "BC",
    "zipCode": "V6B4Y8",
    "country": "CA"
  },
  "260": {
    "city": "Fort Wayne",
    "state": "IN",
    "zipCode": "46802",
    "country": "US"
  },
  "262": {
    "city": "Kenosha",
    "state": "WI",
    "zipCode": "53140",
    "country": "US"
  },
  "263": {
    "city": "Montreal",
    "state": "QC",
    "zipCode": "H2W1K4",
    "country": "CA"
  },
  "267": {
    "city": "Levittown",
    "state": "PA",
    "zipCode": "19055",
    "country": "US"
  },
  "269": {
    "city": "Allegan",
    "state": "MI",
    "zipCode": "49010",
    "country": "US"
  },
  "270": {
    "city": "Bowling Green",
    "state": "KY",
    "zipCode": "42101",
    "country": "US"
  },
  "272": {
    "city": "Back Mountain",
    "state": "PA",
    "zipCode": "18612",
    "country": "US"
  },
  "274": {
    "city": "Green Bay",
    "state": "WI",
    "zipCode": "54301",
    "country": "US"
  },
  "276": {
    "city": "Danville",
    "state": "VA",
    "zipCode": "24540",
    "country": "US"
  },
  "279": {
    "city": "Arden-Arcade",
    "state": "CA",
    "zipCode": "95825",
    "country": "US"
  },
  "281": {
    "city": "Baytown",
    "state": "TX",
    "zipCode": "77520",
    "country": "US"
  },
  "283": {
    "city": "Cincinnati",
    "state": "OH",
    "zipCode": "45201",
    "country": "US"
  },
  "289": {
    "city": "Mississauga",
    "state": "ON",
    "zipCode": "L4T0A2",
    "country": "CA"
  },
  "301": {
    "city": "Aspen Hill",
    "state": "MD",
    "zipCode": "20906",
    "country": "US"
  },
  "302": {
    "city": "Dover",
    "state": "DE",
    "zipCode": "19901",
    "country": "US"
  },
  "303": {
    "city": "Aurora",
    "state": "CO",
    "zipCode": "80010",
    "country": "US"
  },
  "304": {
    "city": "Charleston",
    "state": "WV",
    "zipCode": "25301",
    "country": "US"
  },
  "305": {
    "city": "Miami",
    "state": "FL",
    "zipCode": "33101",
    "country": "US"
  },
  "306": {
    "city": "Regina",
    "state": "SK",
    "zipCode": "S4T3N1",
    "country": "CA"
  },
  "307": {
    "city": "Casper",
    "state": "WY",
    "zipCode": "82601",
    "country": "US"
  },
  "308": {
    "city": "Kearney",
    "state": "NE",
    "zipCode": "68847",
    "country": "US"
  },
  "309": {
    "city": "Bloomington",
    "state": "IL",
    "zipCode": "61701",
    "country": "US"
  },
  "310": {
    "city": "Los Angeles",
    "state": "CA",
    "zipCode": "90001",
    "country": "US"
  },
  "312": {
    "city": "Chicago",
    "state": "IL",
    "zipCode": "60601",
    "country": "US"
  },
  "313": {
    "city": "Dearborn",
    "state": "MI",
    "zipCode": "48120",
    "country": "US"
  },
  "314": {
    "city": "Florissant",
    "state": "MO",
    "zipCode": "63031",
    "country": "US"
  },
  "315": {
    "city": "Syracuse",
    "state": "NY",
    "zipCode": "13201",
    "country": "US"
  },
  "316": {
    "city": "Wichita",
    "state": "KS",
    "zipCode": "67201",
    "country": "US"
  },
  "317": {
    "city": "Indianapolis",
    "state": "IN",
    "zipCode": "46201",
    "country": "US"
  },
  "318": {
    "city": "Bossier City",
    "state": "LA",
    "zipCode": "71111",
    "country": "US"
  },
  "319": {
    "city": "Cedar Rapids",
    "state": "IA",
    "zipCode": "52401",
    "country": "US"
  },
  "320": {
    "city": "Alexandria",
    "state": "MN",
    "zipCode": "56308",
    "country": "US"
  },
  "321": {
    "city": "Melbourne",
    "state": "FL",
    "zipCode": "32901",
    "country": "US"
  },
  "323": {
    "city": "Los Angeles",
    "state": "CA",
    "zipCode": "90001",
    "country": "US"
  },
  "324": {
    "city": "Jacksonville",
    "state": "FL",
    "zipCode": "32201",
    "country": "US"
  },
  "325": {
    "city": "Abilene",
    "state": "TX",
    "zipCode": "79601",
    "country": "US"
  },
  "326": {
    "city": "Dayton",
    "state": "OH",
    "zipCode": "45401",
    "country": "US"
  },
  "327": {
    "city": "Jonesboro",
    "state": "AR",
    "zipCode": "72401",
    "country": "US"
  },
  "329": {
    "city": "Kingston",
    "state": "NY",
    "zipCode": "12401",
    "country": "US"
  },
  "330": {
    "city": "Akron",
    "state": "OH",
    "zipCode": "44301",
    "country": "US"
  },
  "331": {
    "city": "Aurora",
    "state": "IL",
    "zipCode": "60505",
    "country": "US"
  },
  "332": {
    "city": "Manhattan",
    "state": "NY",
    "zipCode": "10001",
    "country": "US"
  },
  "334": {
    "city": "Auburn",
    "state": "AL",
    "zipCode": "36830",
    "country": "US"
  },
  "336": {
    "city": "Greensboro",
    "state": "NC",
    "zipCode": "27401",
    "country": "US"
  },
  "337": {
    "city": "Lafayette",
    "state": "LA",
    "zipCode": "70501",
    "country": "US"
  },
  "339": {
    "city": "Lynn",
    "state": "MA",
    "zipCode": "01901",
    "country": "US"
  },
  "340": {
    "city": "Charlotte Amalie",
    "state": "VI",
    "zipCode": "00802",
    "country": "US"
  },
  "341": {
    "city": "Oakland",
    "state": "CA",
    "zipCode": "94601",
    "country": "US"
  },
  "343": {
    "city": "Ottawa",
    "state": "ON",
    "zipCode": "K2V1A4",
    "country": "CA"
  },
  "346": {
    "city": "Alvin",
    "state": "TX",
    "zipCode": "77511",
    "country": "US"
  },
  "347": {
    "city": "Bronx",
    "state": "NY",
    "zipCode": "10451",
    "country": "US"
  },
  "350": {
    "city": "Lodi",
    "state": "CA",
    "zipCode": "95240",
    "country": "US"
  },
  "351": {
    "city": "Haverhill",
    "state": "MA",
    "zipCode": "01830",
    "country": "US"
  },
  "352": {
    "city": "Gainesville",
    "state": "FL",
    "zipCode": "32601",
    "country": "US"
  },
  "354": {
    "city": "Granby",
    "state": "QC",
    "zipCode": "J2G0A2",
    "country": "CA"
  },
  "357": {
    "city": "Clovis",
    "state": "CA",
    "zipCode": "93611",
    "country": "US"
  },
  "360": {
    "city": "Bellingham",
    "state": "WA",
    "zipCode": "98225",
    "country": "US"
  },
  "361": {
    "city": "Corpus Christi",
    "state": "TX",
    "zipCode": "78401",
    "country": "US"
  },
  "363": {
    "city": "Freeport",
    "state": "NY",
    "zipCode": "11520",
    "country": "US"
  },
  "364": {
    "city": "Owensboro",
    "state": "KY",
    "zipCode": "42301",
    "country": "US"
  },
  "365": {
    "city": "Mississauga",
    "state": "ON",
    "zipCode": "L4T0A2",
    "country": "CA"
  },
  "367": {
    "city": "Saguenay",
    "state": "QC",
    "zipCode": "G0W1Z0",
    "country": "CA"
  },
  "368": {
    "city": "Edmonton",
    "state": "AB",
    "zipCode": "T5J0H6",
    "country": "CA"
  },
  "369": {
    "city": "santa rosa",
    "state": "CA",
    "zipCode": "95401",
    "country": "US"
  },
  "380": {
    "city": "Columbus",
    "state": "OH",
    "zipCode": "43215",
    "country": "US"
  },
  "382": {
    "city": "London",
    "state": "ON",
    "zipCode": "N5V0A2",
    "country": "CA"
  },
  "385": {
    "city": "Ogden",
    "state": "UT",
    "zipCode": "84401",
    "country": "US"
  },
  "386": {
    "city": "Daytona Beach",
    "state": "FL",
    "zipCode": "32114",
    "country": "US"
  },
  "401": {
    "city": "Cranston",
    "state": "RI",
    "zipCode": "02920",
    "country": "US"
  },
  "402": {
    "city": "Columbus",
    "state": "NE",
    "zipCode": "68601",
    "country": "US"
  },
  "403": {
    "city": "Calgary",
    "state": "AB",
    "zipCode": "T2G2W1",
    "country": "CA"
  },
  "404": {
    "city": "Atlanta",
    "state": "GA",
    "zipCode": "30301",
    "country": "US"
  },
  "405": {
    "city": "Midwest City",
    "state": "OK",
    "zipCode": "73110",
    "country": "US"
  },
  "406": {
    "city": "Billings",
    "state": "MT",
    "zipCode": "59101",
    "country": "US"
  },
  "407": {
    "city": "Altamonte Springs",
    "state": "FL",
    "zipCode": "32701",
    "country": "US"
  },
  "408": {
    "city": "Gilroy",
    "state": "CA",
    "zipCode": "95020",
    "country": "US"
  },
  "409": {
    "city": "Beaumont",
    "state": "TX",
    "zipCode": "77701",
    "country": "US"
  },
  "410": {
    "city": "Annapolis",
    "state": "MD",
    "zipCode": "21401",
    "country": "US"
  },
  "412": {
    "city": "Pittsburgh",
    "state": "PA",
    "zipCode": "15201",
    "country": "US"
  },
  "413": {
    "city": "Chicopee",
    "state": "MA",
    "zipCode": "01013",
    "country": "US"
  },
  "414": {
    "city": "Milwaukee",
    "state": "WI",
    "zipCode": "53201",
    "country": "US"
  },
  "415": {
    "city": "San Francisco",
    "state": "CA",
    "zipCode": "94101",
    "country": "US"
  },
  "416": {
    "city": "Toronto",
    "state": "ON",
    "zipCode": "M3C1E6",
    "country": "CA"
  },
  "417": {
    "city": "Springfield",
    "state": "MO",
    "zipCode": "65801",
    "country": "US"
  },
  "418": {
    "city": "Saguenay",
    "state": "QC",
    "zipCode": "G0W1Z0",
    "country": "CA"
  },
  "419": {
    "city": "Toledo",
    "state": "OH",
    "zipCode": "43601",
    "country": "US"
  },
  "423": {
    "city": "Chattanooga",
    "state": "TN",
    "zipCode": "37401",
    "country": "US"
  },
  "424": {
    "city": "Beverly Hills",
    "state": "CA",
    "zipCode": "90210",
    "country": "US"
  },
  "425": {
    "city": "Bellevue",
    "state": "WA",
    "zipCode": "98004",
    "country": "US"
  },
  "428": {
    "city": "Prince William",
    "state": "NB",
    "zipCode": "E6K0A5",
    "country": "CA"
  },
  "430": {
    "city": "Longview",
    "state": "TX",
    "zipCode": "75601",
    "country": "US"
  },
  "431": {
    "city": "Winnipeg",
    "state": "MB",
    "zipCode": "R2C0A5",
    "country": "CA"
  },
  "432": {
    "city": "Midland",
    "state": "TX",
    "zipCode": "79701",
    "country": "US"
  },
  "434": {
    "city": "Lynchburg",
    "state": "VA",
    "zipCode": "24501",
    "country": "US"
  },
  "435": {
    "city": "Cedar City",
    "state": "UT",
    "zipCode": "84720",
    "country": "US"
  },
  "436": {
    "city": "Cleveland",
    "state": "OH",
    "zipCode": "44101",
    "country": "US"
  },
  "437": {
    "city": "Toronto",
    "state": "ON",
    "zipCode": "M3C1E6",
    "country": "CA"
  },
  "438": {
    "city": "Montreal",
    "state": "QC",
    "zipCode": "H2W1K4",
    "country": "CA"
  },
  "440": {
    "city": "Cleveland",
    "state": "OH",
    "zipCode": "44101",
    "country": "US"
  },
  "442": {
    "city": "Apple Valley",
    "state": "CA",
    "zipCode": "92307",
    "country": "US"
  },
  "443": {
    "city": "Baltimore",
    "state": "MD",
    "zipCode": "21201",
    "country": "US"
  },
  "445": {
    "city": "Philadelphia",
    "state": "PA",
    "zipCode": "19101",
    "country": "US"
  },
  "447": {
    "city": "Champaign",
    "state": "IL",
    "zipCode": "61820",
    "country": "US"
  },
  "448": {
    "city": "Pensacola",
    "state": "FL",
    "zipCode": "32501",
    "country": "US"
  },
  "450": {
    "city": "Granby",
    "state": "QC",
    "zipCode": "J2G0A2",
    "country": "CA"
  },
  "457": {
    "city": "Bossier City",
    "state": "LA",
    "zipCode": "71111",
    "country": "US"
  },
  "458": {
    "city": "Eugene",
    "state": "OR",
    "zipCode": "97401",
    "country": "US"
  },
  "463": {
    "city": "Carmel",
    "state": "IN",
    "zipCode": "46032",
    "country": "US"
  },
  "464": {
    "city": "Cicero",
    "state": "IL",
    "zipCode": "60804",
    "country": "US"
  },
  "468": {
    "city": "Sherbrooke",
    "state": "QC",
    "zipCode": "J1C0A6",
    "country": "CA"
  },
  "469": {
    "city": "Carrollton",
    "state": "TX",
    "zipCode": "75006",
    "country": "US"
  },
  "470": {
    "city": "Atlanta",
    "state": "GA",
    "zipCode": "30301",
    "country": "US"
  },
  "472": {
    "city": "Fayetteville",
    "state": "NC",
    "zipCode": "28301",
    "country": "US"
  },
  "474": {
    "city": "Regina",
    "state": "SK",
    "zipCode": "S4T3N1",
    "country": "CA"
  },
  "475": {
    "city": "Bridgeport",
    "state": "CT",
    "zipCode": "06601",
    "country": "US"
  },
  "478": {
    "city": "Macon",
    "state": "GA",
    "zipCode": "31201",
    "country": "US"
  },
  "479": {
    "city": "Fayetteville",
    "state": "AR",
    "zipCode": "72701",
    "country": "US"
  },
  "480": {
    "city": "Chandler",
    "state": "AZ",
    "zipCode": "85224",
    "country": "US"
  },
  "483": {
    "city": "Auburn",
    "state": "AL",
    "zipCode": "36830",
    "country": "US"
  },
  "484": {
    "city": "Allentown",
    "state": "PA",
    "zipCode": "18101",
    "country": "US"
  },
  "501": {
    "city": "Little Rock",
    "state": "AR",
    "zipCode": "72201",
    "country": "US"
  },
  "502": {
    "city": "Louisville",
    "state": "KY",
    "zipCode": "40201",
    "country": "US"
  },
  "503": {
    "city": "Beaver",
    "state": "OR",
    "zipCode": "97004",
    "country": "US"
  },
  "504": {
    "city": "Kenner",
    "state": "LA",
    "zipCode": "70062",
    "country": "US"
  },
  "505": {
    "city": "Albuquerque",
    "state": "NM",
    "zipCode": "87101",
    "country": "US"
  },
  "506": {
    "city": "Prince William",
    "state": "NB",
    "zipCode": "E6K0A5",
    "country": "CA"
  },
  "507": {
    "city": "Austin",
    "state": "MN",
    "zipCode": "55912",
    "country": "US"
  },
  "508": {
    "city": "Cambridge",
    "state": "MA",
    "zipCode": "02138",
    "country": "US"
  },
  "509": {
    "city": "Kennewick",
    "state": "WA",
    "zipCode": "99336",
    "country": "US"
  },
  "510": {
    "city": "Alameda",
    "state": "CA",
    "zipCode": "94501",
    "country": "US"
  },
  "512": {
    "city": "Austin",
    "state": "TX",
    "zipCode": "78701",
    "country": "US"
  },
  "513": {
    "city": "Cincinnati",
    "state": "OH",
    "zipCode": "45201",
    "country": "US"
  },
  "514": {
    "city": "Montreal",
    "state": "QC",
    "zipCode": "H2W1K4",
    "country": "CA"
  },
  "515": {
    "city": "Ames",
    "state": "IA",
    "zipCode": "50010",
    "country": "US"
  },
  "516": {
    "city": "Freeport",
    "state": "NY",
    "zipCode": "11520",
    "country": "US"
  },
  "517": {
    "city": "Charlotte",
    "state": "MI",
    "zipCode": "48813",
    "country": "US"
  },
  "518": {
    "city": "Albany",
    "state": "NY",
    "zipCode": "12201",
    "country": "US"
  },
  "519": {
    "city": "London",
    "state": "ON",
    "zipCode": "N5V0A2",
    "country": "CA"
  },
  "520": {
    "city": "Casas Adobes",
    "state": "AZ",
    "zipCode": "85701",
    "country": "US"
  },
  "530": {
    "city": "Chico",
    "state": "CA",
    "zipCode": "95926",
    "country": "US"
  },
  "531": {
    "city": "Omaha",
    "state": "NE",
    "zipCode": "68101",
    "country": "US"
  },
  "534": {
    "city": "Eau Claire",
    "state": "WI",
    "zipCode": "54701",
    "country": "US"
  },
  "539": {
    "city": "Bartlesville",
    "state": "OK",
    "zipCode": "74003",
    "country": "US"
  },
  "540": {
    "city": "Blacksburg",
    "state": "VA",
    "zipCode": "24060",
    "country": "US"
  },
  "541": {
    "city": "Bend",
    "state": "OR",
    "zipCode": "97701",
    "country": "US"
  },
  "548": {
    "city": "London",
    "state": "ON",
    "zipCode": "N5V0A2",
    "country": "CA"
  },
  "551": {
    "city": "Bayonne",
    "state": "NJ",
    "zipCode": "07002",
    "country": "US"
  },
  "557": {
    "city": "St. Louis",
    "state": "MO",
    "zipCode": "63101",
    "country": "US"
  },
  "559": {
    "city": "Clovis",
    "state": "CA",
    "zipCode": "93611",
    "country": "US"
  },
  "561": {
    "city": "Boca Raton",
    "state": "FL",
    "zipCode": "33431",
    "country": "US"
  },
  "562": {
    "city": "Bellflower",
    "state": "CA",
    "zipCode": "90706",
    "country": "US"
  },
  "563": {
    "city": "Davenport",
    "state": "IA",
    "zipCode": "52801",
    "country": "US"
  },
  "564": {
    "city": "Seattle",
    "state": "WA",
    "zipCode": "98101",
    "country": "US"
  },
  "567": {
    "city": "Toledo",
    "state": "OH",
    "zipCode": "43601",
    "country": "US"
  },
  "570": {
    "city": "Scranton",
    "state": "PA",
    "zipCode": "18501",
    "country": "US"
  },
  "571": {
    "city": "Alexandria",
    "state": "VA",
    "zipCode": "22301",
    "country": "US"
  },
  "573": {
    "city": "Columbia",
    "state": "MO",
    "zipCode": "65201",
    "country": "US"
  },
  "574": {
    "city": "Elkhart",
    "state": "IN",
    "zipCode": "46514",
    "country": "US"
  },
  "575": {
    "city": "Alamogordo",
    "state": "NM",
    "zipCode": "88310",
    "country": "US"
  },
  "579": {
    "city": "Granby",
    "state": "QC",
    "zipCode": "J2G0A2",
    "country": "CA"
  },
  "580": {
    "city": "Lawton",
    "state": "OK",
    "zipCode": "73501",
    "country": "US"
  },
  "581": {
    "city": "Saguenay",
    "state": "QC",
    "zipCode": "G0W1Z0",
    "country": "CA"
  },
  "582": {
    "city": "Erie",
    "state": "PA",
    "zipCode": "16501",
    "country": "US"
  },
  "584": {
    "city": "Winnipeg",
    "state": "MB",
    "zipCode": "R2C0A5",
    "country": "CA"
  },
  "585": {
    "city": "Arcade",
    "state": "NY",
    "zipCode": "14009",
    "country": "US"
  },
  "586": {
    "city": "Sterling Heights",
    "state": "MI",
    "zipCode": "48310",
    "country": "US"
  },
  "587": {
    "city": "Edmonton",
    "state": "AB",
    "zipCode": "T5J0H6",
    "country": "CA"
  },
  "601": {
    "city": "Hattiesburg",
    "state": "MS",
    "zipCode": "39401",
    "country": "US"
  },
  "602": {
    "city": "Phoenix",
    "state": "AZ",
    "zipCode": "85001",
    "country": "US"
  },
  "603": {
    "city": "Dover",
    "state": "NH",
    "zipCode": "03820",
    "country": "US"
  },
  "604": {
    "city": "Vancouver",
    "state": "BC",
    "zipCode": "V6B4Y8",
    "country": "CA"
  },
  "605": {
    "city": "Rapid City",
    "state": "SD",
    "zipCode": "57701",
    "country": "US"
  },
  "606": {
    "city": "Ashland",
    "state": "KY",
    "zipCode": "41101",
    "country": "US"
  },
  "607": {
    "city": "Elmira",
    "state": "NY",
    "zipCode": "14901",
    "country": "US"
  },
  "608": {
    "city": "Janesville",
    "state": "WI",
    "zipCode": "53545",
    "country": "US"
  },
  "609": {
    "city": "Allentown",
    "state": "NJ",
    "zipCode": "08501",
    "country": "US"
  },
  "610": {
    "city": "Allentown",
    "state": "PA",
    "zipCode": "18101",
    "country": "US"
  },
  "612": {
    "city": "Minneapolis",
    "state": "MN",
    "zipCode": "55401",
    "country": "US"
  },
  "613": {
    "city": "Ottawa",
    "state": "ON",
    "zipCode": "K2V1A4",
    "country": "CA"
  },
  "614": {
    "city": "Columbus",
    "state": "OH",
    "zipCode": "43215",
    "country": "US"
  },
  "615": {
    "city": "Murfreesboro",
    "state": "TN",
    "zipCode": "37130",
    "country": "US"
  },
  "616": {
    "city": "Grand Rapids",
    "state": "MI",
    "zipCode": "49501",
    "country": "US"
  },
  "617": {
    "city": "Boston",
    "state": "MA",
    "zipCode": "02108",
    "country": "US"
  },
  "618": {
    "city": "Alton",
    "state": "IL",
    "zipCode": "62002",
    "country": "US"
  },
  "619": {
    "city": "Chula Vista",
    "state": "CA",
    "zipCode": "91910",
    "country": "US"
  },
  "620": {
    "city": "Dodge City",
    "state": "KS",
    "zipCode": "67801",
    "country": "US"
  },
  "621": {
    "city": "Houston",
    "state": "TX",
    "zipCode": "77001",
    "country": "US"
  },
  "623": {
    "city": "Phoenix",
    "state": "AZ",
    "zipCode": "85001",
    "country": "US"
  },
  "624": {
    "city": "Cattaraugus",
    "state": "NY",
    "zipCode": "14719",
    "country": "US"
  },
  "626": {
    "city": "Alhambra",
    "state": "CA",
    "zipCode": "91801",
    "country": "US"
  },
  "627": {
    "city": "Santa Rosa",
    "state": "CA",
    "zipCode": "95401",
    "country": "US"
  },
  "628": {
    "city": "San Francisco",
    "state": "CA",
    "zipCode": "94101",
    "country": "US"
  },
  "629": {
    "city": "Brentwood",
    "state": "TN",
    "zipCode": "37027",
    "country": "US"
  },
  "630": {
    "city": "Naperville",
    "state": "IL",
    "zipCode": "60540",
    "country": "US"
  },
  "631": {
    "city": "Babylon",
    "state": "NY",
    "zipCode": "11702",
    "country": "US"
  },
  "636": {
    "city": "St. Charles",
    "state": "MO",
    "zipCode": "63301",
    "country": "US"
  },
  "639": {
    "city": "Regina",
    "state": "SK",
    "zipCode": "S4T3N1",
    "country": "CA"
  },
  "640": {
    "city": "Allentown",
    "state": "NJ",
    "zipCode": "08501",
    "country": "US"
  },
  "641": {
    "city": "Mason City",
    "state": "IA",
    "zipCode": "50401",
    "country": "US"
  },
  "645": {
    "city": "Miami",
    "state": "FL",
    "zipCode": "33101",
    "country": "US"
  },
  "646": {
    "city": "New York City",
    "state": "NY",
    "zipCode": "10001",
    "country": "US"
  },
  "647": {
    "city": "Toronto",
    "state": "ON",
    "zipCode": "M3C1E6",
    "country": "CA"
  },
  "650": {
    "city": "Daly City",
    "state": "CA",
    "zipCode": "94014",
    "country": "US"
  },
  "651": {
    "city": "St. Paul",
    "state": "MN",
    "zipCode": "55101",
    "country": "US"
  },
  "656": {
    "city": "Tampa",
    "state": "FL",
    "zipCode": "33601",
    "country": "US"
  },
  "657": {
    "city": "Anaheim",
    "state": "CA",
    "zipCode": "92801",
    "country": "US"
  },
  "659": {
    "city": "Birmingham",
    "state": "AL",
    "zipCode": "35201",
    "country": "US"
  },
  "660": {
    "city": "Marshall",
    "state": "MO",
    "zipCode": "65340",
    "country": "US"
  },
  "661": {
    "city": "Earlimart",
    "state": "CA",
    "zipCode": "93219",
    "country": "US"
  },
  "662": {
    "city": "Starkville",
    "state": "MS",
    "zipCode": "39759",
    "country": "US"
  },
  "667": {
    "city": "Baltimore",
    "state": "MD",
    "zipCode": "21201",
    "country": "US"
  },
  "669": {
    "city": "San Jose",
    "state": "CA",
    "zipCode": "95101",
    "country": "US"
  },
  "670": {
    "city": "saipan",
    "state": "MP",
    "zipCode": "96950",
    "country": "US"
  },
  "671": {
    "city": "Hagatna",
    "state": "GU",
    "zipCode": "96910",
    "country": "US"
  },
  "672": {
    "city": "Vancouver",
    "state": "BC",
    "zipCode": "V6B4Y8",
    "country": "CA"
  },
  "678": {
    "city": "Atlanta",
    "state": "GA",
    "zipCode": "30301",
    "country": "US"
  },
  "679": {
    "city": "Detroit",
    "state": "MI",
    "zipCode": "48201",
    "country": "US"
  },
  "680": {
    "city": "Auburn",
    "state": "NY",
    "zipCode": "13021",
    "country": "US"
  },
  "681": {
    "city": "Charleston",
    "state": "WV",
    "zipCode": "25301",
    "country": "US"
  },
  "682": {
    "city": "Arlington",
    "state": "TX",
    "zipCode": "76010",
    "country": "US"
  },
  "683": {
    "city": "Sudbury",
    "state": "ON",
    "zipCode": "P3A0A4",
    "country": "CA"
  },
  "684": {
    "city": "Pago Pago",
    "state": "AS",
    "zipCode": "96799",
    "country": "US"
  },
  "686": {
    "city": "Mechanicsville",
    "state": "VA",
    "zipCode": "23111",
    "country": "US"
  },
  "689": {
    "city": "Orlando",
    "state": "FL",
    "zipCode": "32801",
    "country": "US"
  },
  "701": {
    "city": "Bismarck",
    "state": "ND",
    "zipCode": "58501",
    "country": "US"
  },
  "702": {
    "city": "Henderson",
    "state": "NV",
    "zipCode": "89011",
    "country": "US"
  },
  "703": {
    "city": "Alexandria",
    "state": "VA",
    "zipCode": "22301",
    "country": "US"
  },
  "704": {
    "city": "Charlotte",
    "state": "NC",
    "zipCode": "28202",
    "country": "US"
  },
  "705": {
    "city": "Sudbury",
    "state": "ON",
    "zipCode": "P3A0A4",
    "country": "CA"
  },
  "706": {
    "city": "Athens",
    "state": "GA",
    "zipCode": "30601",
    "country": "US"
  },
  "707": {
    "city": "Benicia",
    "state": "CA",
    "zipCode": "94510",
    "country": "US"
  },
  "708": {
    "city": "Berwyn",
    "state": "IL",
    "zipCode": "60402",
    "country": "US"
  },
  "709": {
    "city": "St. John's",
    "state": "NL",
    "zipCode": "A1E1T2",
    "country": "CA"
  },
  "712": {
    "city": "Council Bluffs",
    "state": "IA",
    "zipCode": "51501",
    "country": "US"
  },
  "713": {
    "city": "Houston",
    "state": "TX",
    "zipCode": "77001",
    "country": "US"
  },
  "714": {
    "city": "Anaheim",
    "state": "CA",
    "zipCode": "92801",
    "country": "US"
  },
  "715": {
    "city": "Chippewa Falls",
    "state": "WI",
    "zipCode": "54729",
    "country": "US"
  },
  "716": {
    "city": "Cattaraugus",
    "state": "NY",
    "zipCode": "14719",
    "country": "US"
  },
  "717": {
    "city": "Lancaster",
    "state": "PA",
    "zipCode": "17601",
    "country": "US"
  },
  "718": {
    "city": "Bellerose",
    "state": "NY",
    "zipCode": "11426",
    "country": "US"
  },
  "719": {
    "city": "Alamosa",
    "state": "CO",
    "zipCode": "81101",
    "country": "US"
  },
  "720": {
    "city": "Boulder",
    "state": "CO",
    "zipCode": "80301",
    "country": "US"
  },
  "724": {
    "city": "New Castle",
    "state": "PA",
    "zipCode": "16101",
    "country": "US"
  },
  "725": {
    "city": "Henderson",
    "state": "NV",
    "zipCode": "89011",
    "country": "US"
  },
  "726": {
    "city": "San Antonio",
    "state": "TX",
    "zipCode": "78201",
    "country": "US"
  },
  "727": {
    "city": "Clearwater",
    "state": "FL",
    "zipCode": "33755",
    "country": "US"
  },
  "728": {
    "city": "Boca Raton",
    "state": "FL",
    "zipCode": "33431",
    "country": "US"
  },
  "729": {
    "city": "Chattanooga",
    "state": "TN",
    "zipCode": "37401",
    "country": "US"
  },
  "730": {
    "city": "Alton",
    "state": "IL",
    "zipCode": "62002",
    "country": "US"
  },
  "731": {
    "city": "Jackson",
    "state": "TN",
    "zipCode": "38301",
    "country": "US"
  },
  "732": {
    "city": "Brick Township",
    "state": "NJ",
    "zipCode": "08723",
    "country": "US"
  },
  "734": {
    "city": "Ann Arbor",
    "state": "MI",
    "zipCode": "48103",
    "country": "US"
  },
  "737": {
    "city": "Austin",
    "state": "TX",
    "zipCode": "73301",
    "country": "US"
  },
  "738": {
    "city": "Los Angeles",
    "state": "CA",
    "zipCode": "90015",
    "country": "US"
  },
  "740": {
    "city": "Athens",
    "state": "OH",
    "zipCode": "45701",
    "country": "US"
  },
  "742": {
    "city": "Mississauga",
    "state": "ON",
    "zipCode": "L4T0A2",
    "country": "CA"
  },
  "743": {
    "city": "Greensboro",
    "state": "NC",
    "zipCode": "27401",
    "country": "US"
  },
  "747": {
    "city": "Burbank",
    "state": "CA",
    "zipCode": "91501",
    "country": "US"
  },
  "748": {
    "city": "Durango",
    "state": "CO",
    "zipCode": "81301",
    "country": "US"
  },
  "753": {
    "city": "Ottawa",
    "state": "ON",
    "zipCode": "K2V1A4",
    "country": "CA"
  },
  "754": {
    "city": "Coral Springs",
    "state": "FL",
    "zipCode": "33065",
    "country": "US"
  },
  "757": {
    "city": "Chesapeake",
    "state": "VA",
    "zipCode": "23320",
    "country": "US"
  },
  "760": {
    "city": "Apple Valley",
    "state": "CA",
    "zipCode": "92307",
    "country": "US"
  },
  "762": {
    "city": "Athens",
    "state": "GA",
    "zipCode": "30601",
    "country": "US"
  },
  "763": {
    "city": "Brooklyn Park",
    "state": "MN",
    "zipCode": "55443",
    "country": "US"
  },
  "765": {
    "city": "Kokomo",
    "state": "IN",
    "zipCode": "46901",
    "country": "US"
  },
  "769": {
    "city": "Hattiesburg",
    "state": "MS",
    "zipCode": "39401",
    "country": "US"
  },
  "770": {
    "city": "Atlanta",
    "state": "GA",
    "zipCode": "30301",
    "country": "US"
  },
  "771": {
    "city": "Washington",
    "state": "DC",
    "zipCode": "20001",
    "country": "US"
  },
  "772": {
    "city": "Port St. Lucie",
    "state": "FL",
    "zipCode": "34952",
    "country": "US"
  },
  "773": {
    "city": "Chicago",
    "state": "IL",
    "zipCode": "60601",
    "country": "US"
  },
  "774": {
    "city": "Brockton",
    "state": "MA",
    "zipCode": "02301",
    "country": "US"
  },
  "775": {
    "city": "Carson City",
    "state": "NV",
    "zipCode": "89701",
    "country": "US"
  },
  "778": {
    "city": "Victoria",
    "state": "BC",
    "zipCode": "V8P5N3",
    "country": "CA"
  },
  "779": {
    "city": "Joliet",
    "state": "IL",
    "zipCode": "60431",
    "country": "US"
  },
  "780": {
    "city": "Edmonton",
    "state": "AB",
    "zipCode": "T5J0H6",
    "country": "CA"
  },
  "781": {
    "city": "Lynn",
    "state": "MA",
    "zipCode": "01901",
    "country": "US"
  },
  "782": {
    "city": "Halifax",
    "state": "NS",
    "zipCode": "B3H0A4",
    "country": "CA"
  },
  "785": {
    "city": "Abilene",
    "state": "KS",
    "zipCode": "67410",
    "country": "US"
  },
  "786": {
    "city": "Hialeah",
    "state": "FL",
    "zipCode": "33010",
    "country": "US"
  },
  "800": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "801": {
    "city": "Ogden",
    "state": "UT",
    "zipCode": "84401",
    "country": "US"
  },
  "802": {
    "city": "Bennington",
    "state": "VT",
    "zipCode": "05201",
    "country": "US"
  },
  "803": {
    "city": "Columbia",
    "state": "SC",
    "zipCode": "29201",
    "country": "US"
  },
  "804": {
    "city": "Mechanicsville",
    "state": "VA",
    "zipCode": "23111",
    "country": "US"
  },
  "805": {
    "city": "Camarillo",
    "state": "CA",
    "zipCode": "93010",
    "country": "US"
  },
  "806": {
    "city": "Amarillo",
    "state": "TX",
    "zipCode": "79101",
    "country": "US"
  },
  "807": {
    "city": "Kenora",
    "state": "ON",
    "zipCode": "P9N0A3",
    "country": "CA"
  },
  "808": {
    "city": "Honolulu",
    "state": "HI",
    "zipCode": "96801",
    "country": "US"
  },
  "810": {
    "city": "Flint",
    "state": "MI",
    "zipCode": "48501",
    "country": "US"
  },
  "812": {
    "city": "Bloomington",
    "state": "IN",
    "zipCode": "47401",
    "country": "US"
  },
  "813": {
    "city": "Tampa",
    "state": "FL",
    "zipCode": "33601",
    "country": "US"
  },
  "814": {
    "city": "Erie",
    "state": "PA",
    "zipCode": "16501",
    "country": "US"
  },
  "815": {
    "city": "Joliet",
    "state": "IL",
    "zipCode": "60431",
    "country": "US"
  },
  "816": {
    "city": "Kansas City",
    "state": "MO",
    "zipCode": "64101",
    "country": "US"
  },
  "817": {
    "city": "Arlington",
    "state": "TX",
    "zipCode": "76010",
    "country": "US"
  },
  "818": {
    "city": "Agoura Hills",
    "state": "CA",
    "zipCode": "91301",
    "country": "US"
  },
  "819": {
    "city": "Sherbrooke",
    "state": "QC",
    "zipCode": "J1C0A6",
    "country": "CA"
  },
  "820": {
    "city": "Camarillo",
    "state": "CA",
    "zipCode": "93010",
    "country": "US"
  },
  "821": {
    "city": "Greenville",
    "state": "SC",
    "zipCode": "29601",
    "country": "US"
  },
  "822": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "825": {
    "city": "Edmonton",
    "state": "AB",
    "zipCode": "T5J0H6",
    "country": "CA"
  },
  "826": {
    "city": "Blacksburg",
    "state": "VA",
    "zipCode": "24060",
    "country": "US"
  },
  "828": {
    "city": "Asheville",
    "state": "NC",
    "zipCode": "28801",
    "country": "US"
  },
  "830": {
    "city": "Medina",
    "state": "TX",
    "zipCode": "78055",
    "country": "US"
  },
  "831": {
    "city": "Salinas",
    "state": "CA",
    "zipCode": "93901",
    "country": "US"
  },
  "832": {
    "city": "Baytown",
    "state": "TX",
    "zipCode": "77520",
    "country": "US"
  },
  "833": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "835": {
    "city": "Allentown",
    "state": "PA",
    "zipCode": "18101",
    "country": "US"
  },
  "837": {
    "city": "Chico",
    "state": "CA",
    "zipCode": "95926",
    "country": "US"
  },
  "838": {
    "city": "Albany",
    "state": "NY",
    "zipCode": "12201",
    "country": "US"
  },
  "839": {
    "city": "Columbia",
    "state": "SC",
    "zipCode": "29201",
    "country": "US"
  },
  "840": {
    "city": "Anaheim",
    "state": "CA",
    "zipCode": "92801",
    "country": "US"
  },
  "843": {
    "city": "Charleston",
    "state": "SC",
    "zipCode": "29401",
    "country": "US"
  },
  "844": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "845": {
    "city": "Kingston",
    "state": "NY",
    "zipCode": "12401",
    "country": "US"
  },
  "847": {
    "city": "Arlington Heights",
    "state": "IL",
    "zipCode": "60004",
    "country": "US"
  },
  "848": {
    "city": "Brick Township",
    "state": "NJ",
    "zipCode": "08723",
    "country": "US"
  },
  "850": {
    "city": "Pensacola",
    "state": "FL",
    "zipCode": "32501",
    "country": "US"
  },
  "854": {
    "city": "Charleston",
    "state": "SC",
    "zipCode": "29401",
    "country": "US"
  },
  "855": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "856": {
    "city": "Camden",
    "state": "NJ",
    "zipCode": "08101",
    "country": "US"
  },
  "857": {
    "city": "Boston",
    "state": "MA",
    "zipCode": "02101",
    "country": "US"
  },
  "858": {
    "city": "San Diego",
    "state": "CA",
    "zipCode": "92101",
    "country": "US"
  },
  "859": {
    "city": "Lexington",
    "state": "KY",
    "zipCode": "40502",
    "country": "US"
  },
  "860": {
    "city": "Bristol",
    "state": "CT",
    "zipCode": "06010",
    "country": "US"
  },
  "861": {
    "city": "Bloomington",
    "state": "IL",
    "zipCode": "61701",
    "country": "US"
  },
  "862": {
    "city": "Clifton",
    "state": "NJ",
    "zipCode": "07011",
    "country": "US"
  },
  "863": {
    "city": "Lakeland",
    "state": "FL",
    "zipCode": "33801",
    "country": "US"
  },
  "864": {
    "city": "Greenville",
    "state": "SC",
    "zipCode": "29601",
    "country": "US"
  },
  "865": {
    "city": "Knoxville",
    "state": "TN",
    "zipCode": "37901",
    "country": "US"
  },
  "866": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "867": {
    "city": "Whitehorse",
    "state": "YT",
    "zipCode": "Y1A0A4",
    "country": "CA"
  },
  "870": {
    "city": "Jonesboro",
    "state": "AR",
    "zipCode": "72401",
    "country": "US"
  },
  "872": {
    "city": "Chicago",
    "state": "IL",
    "zipCode": "60601",
    "country": "US"
  },
  "873": {
    "city": "Sherbrooke",
    "state": "QC",
    "zipCode": "J1C0A6",
    "country": "CA"
  },
  "877": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "878": {
    "city": "Pittsburgh",
    "state": "PA",
    "zipCode": "15201",
    "country": "US"
  },
  "879": {
    "city": "St. John's",
    "state": "NL",
    "zipCode": "A1E1T2",
    "country": "CA"
  },
  "880": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "881": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "882": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "883": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "884": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "885": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "886": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "887": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "888": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "889": {
    "city": null,
    "state": null,
    "zipCode": null,
    "country": null
  },
  "901": {
    "city": "Memphis",
    "state": "TN",
    "zipCode": "38101",
    "country": "US"
  },
  "902": {
    "city": "Halifax",
    "state": "NS",
    "zipCode": "B3H0A4",
    "country": "CA"
  },
  "903": {
    "city": "Longview",
    "state": "TX",
    "zipCode": "75601",
    "country": "US"
  },
  "904": {
    "city": "Jacksonville",
    "state": "FL",
    "zipCode": "32201",
    "country": "US"
  },
  "905": {
    "city": "Mississauga",
    "state": "ON",
    "zipCode": "L4T0A2",
    "country": "CA"
  },
  "906": {
    "city": "Sault Ste Marie",
    "state": "MI",
    "zipCode": "49783",
    "country": "US"
  },
  "907": {
    "city": "Anchorage",
    "state": "AK",
    "zipCode": "99501",
    "country": "US"
  },
  "908": {
    "city": "Washington Township",
    "state": "NJ",
    "zipCode": "07676",
    "country": "US"
  },
  "909": {
    "city": "Anaheim",
    "state": "CA",
    "zipCode": "92801",
    "country": "US"
  },
  "910": {
    "city": "Fayetteville",
    "state": "NC",
    "zipCode": "28301",
    "country": "US"
  },
  "912": {
    "city": "Savannah",
    "state": "GA",
    "zipCode": "31401",
    "country": "US"
  },
  "913": {
    "city": "Kansas City",
    "state": "KS",
    "zipCode": "66101",
    "country": "US"
  },
  "914": {
    "city": "Mount Vernon",
    "state": "NY",
    "zipCode": "10550",
    "country": "US"
  },
  "915": {
    "city": "El Paso",
    "state": "TX",
    "zipCode": "79901",
    "country": "US"
  },
  "916": {
    "city": "Elk Grove",
    "state": "CA",
    "zipCode": "95624",
    "country": "US"
  },
  "917": {
    "city": "New York City",
    "state": "NY",
    "zipCode": "10001",
    "country": "US"
  },
  "918": {
    "city": "Broken Arrow",
    "state": "OK",
    "zipCode": "74011",
    "country": "US"
  },
  "919": {
    "city": "Cary",
    "state": "NC",
    "zipCode": "27511",
    "country": "US"
  },
  "920": {
    "city": "Appleton",
    "state": "WI",
    "zipCode": "54911",
    "country": "US"
  },
  "924": {
    "city": "Austin",
    "state": "MN",
    "zipCode": "55912",
    "country": "US"
  },
  "925": {
    "city": "Antioch",
    "state": "CA",
    "zipCode": "94509",
    "country": "US"
  },
  "928": {
    "city": "Flagstaff",
    "state": "AZ",
    "zipCode": "86001",
    "country": "US"
  },
  "929": {
    "city": "Bellerose",
    "state": "NY",
    "zipCode": "11426",
    "country": "US"
  },
  "930": {
    "city": "Bloomington",
    "state": "IN",
    "zipCode": "47401",
    "country": "US"
  },
  "931": {
    "city": "Clarksville",
    "state": "TN",
    "zipCode": "37040",
    "country": "US"
  },
  "934": {
    "city": "Babylon",
    "state": "NY",
    "zipCode": "11702",
    "country": "US"
  },
  "936": {
    "city": "Huntsville",
    "state": "TX",
    "zipCode": "77320",
    "country": "US"
  },
  "937": {
    "city": "Dayton",
    "state": "OH",
    "zipCode": "45401",
    "country": "US"
  },
  "938": {
    "city": "Huntsville",
    "state": "AL",
    "zipCode": "35801",
    "country": "US"
  },
  "940": {
    "city": "Denton",
    "state": "TX",
    "zipCode": "76201",
    "country": "US"
  },
  "941": {
    "city": "Sarasota",
    "state": "FL",
    "zipCode": "34230",
    "country": "US"
  },
  "942": {
    "city": "Toronto",
    "state": "ON",
    "zipCode": "M3C1E6",
    "country": "CA"
  },
  "943": {
    "city": "Atlanta",
    "state": "GA",
    "zipCode": "30301",
    "country": "US"
  },
  "945": {
    "city": "Dallas",
    "state": "TX",
    "zipCode": "75201",
    "country": "US"
  },
  "947": {
    "city": "Farmington Hills",
    "state": "MI",
    "zipCode": "48331",
    "country": "US"
  },
  "948": {
    "city": "Chesapeake",
    "state": "VA",
    "zipCode": "23320",
    "country": "US"
  },
  "949": {
    "city": "Costa Mesa",
    "state": "CA",
    "zipCode": "92626",
    "country": "US"
  },
  "951": {
    "city": "Corona",
    "state": "CA",
    "zipCode": "92877",
    "country": "US"
  },
  "952": {
    "city": "Bloomington",
    "state": "MN",
    "zipCode": "55420",
    "country": "US"
  },
  "954": {
    "city": "Fort Lauderdale",
    "state": "FL",
    "zipCode": "33301",
    "country": "US"
  },
  "956": {
    "city": "Laredo",
    "state": "TX",
    "zipCode": "78040",
    "country": "US"
  },
  "959": {
    "city": "Hartford",
    "state": "CT",
    "zipCode": "06101",
    "country": "US"
  },
  "970": {
    "city": "Durango",
    "state": "CO",
    "zipCode": "81301",
    "country": "US"
  },
  "971": {
    "city": "Beaverton",
    "state": "OR",
    "zipCode": "97005",
    "country": "US"
  },
  "972": {
    "city": "Carrollton",
    "state": "TX",
    "zipCode": "75006",
    "country": "US"
  },
  "973": {
    "city": "Newark",
    "state": "NJ",
    "zipCode": "07101",
    "country": "US"
  },
  "975": {
    "city": "Kansas City",
    "state": "MO",
    "zipCode": "64101",
    "country": "US"
  },
  "978": {
    "city": "Haverhill",
    "state": "MA",
    "zipCode": "01830",
    "country": "US"
  },
  "979": {
    "city": "Bryan",
    "state": "TX",
    "zipCode": "77801",
    "country": "US"
  },
  "980": {
    "city": "Charlotte",
    "state": "NC",
    "zipCode": "28201",
    "country": "US"
  },
  "983": {
    "city": "Aurora",
    "state": "CO",
    "zipCode": "80010",
    "country": "US"
  },
  "984": {
    "city": "Raleigh",
    "state": "NC",
    "zipCode": "27601",
    "country": "US"
  },
  "985": {
    "city": "Hammond",
    "state": "LA",
    "zipCode": "70401",
    "country": "US"
  },
  "986": {
    "city": "Boise",
    "state": "ID",
    "zipCode": "83701",
    "country": "US"
  },
  "989": {
    "city": "Alma",
    "state": "MI",
    "zipCode": "48801",
    "country": "US"
  }
}